/**
 * Gzip a raw JSON bundle while preserving an already-compressed bundle unchanged.
 *
 * @param file - User-selected `.json` or compressed TLF bundle file
 * @returns Compressed bundle Blob
 */
export const compressBundleFile = async (file: File): Promise<Blob> => {
  const fileName = file.name.toLowerCase();
  if (/(?:\.tlfbundle|-tlfbundle)(?: \(\d+\))?\.gz$/.test(fileName)) return file;
  if (!fileName.endsWith(".json")) {
    throw new Error("Select a -tlfbundle.gz, .tlfbundle.gz, or .json file");
  }
  if (typeof CompressionStream === "undefined") {
    throw new Error("Gzip compression is not supported by this browser");
  }

  const stream = file.stream().pipeThrough(new CompressionStream("gzip"));
  const compressed = await new Response(stream).blob();
  return new Blob([compressed], { type: "application/gzip" });
};
